import { atomWithReset } from "jotai/utils";
export const addedStepsAtom = atomWithReset("load");
